export const startBidMission = (id) => ({
  type: "START_BID_MISSION",
  id
});



// WEBPACK FOOTER //
// ./src/store/actions/help/bids.js